import "../../../css/DesignSystem/Inputs/InputField.css";

const TextArea = ({
  id,
  name,
  label,
  value,
  onChange,
  placeholder,
  error = false,
  helperText,
  required = false,
  disabled = false,
  readOnly = false,
  rows = 6,
}) => {
  const textareaId =
    id || `textarea-${label?.replace(/\s+/g, "-")?.toLowerCase()}`;
  const textareaName = name || id;

  const handleChange = (e) => {
    if (onChange) {
      onChange(e);
    }
  };

  return (
    <div
      className={`ds-textarea-field ${error ? "ds-textarea-field--error" : ""}`}
    >
      {label && (
        <label className="ds-textarea-label" htmlFor={textareaId}>
          {label}
          {required && <span className="ds-textarea-required">*</span>}
        </label>
      )}
      <div className="ds-textarea-wrapper">
        <textarea
          id={textareaId}
          name={textareaName}
          className="ds-textarea long-textarea"
          rows={rows}
          value={value}
          onChange={handleChange}
          placeholder={placeholder}
          disabled={disabled}
          readOnly={readOnly}
          style={{
            width: "100%",
            boxSizing: "border-box",
            borderColor: error ? "var(--Error)" : undefined,
            borderWidth: error ? "2px" : undefined,
          }}
        />
      </div>
      {/* {showError && error && <p className="ds-textarea-error">{error}</p>}
      {helperText && !error && (
        <p className="ds-textarea-helper">{helperText}</p>
      )} */}
    </div>
  );
};

export default TextArea;
